import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import styled, { css } from 'styled-components';
import { Input, Link, Dropdown } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import InputTilePopoverCard from './InputTilePopoverCard';
import {
  modalActions,
  inputTilesActions,
  retirementIncomeGoalActions,
  riScenarioActions,
  participantProfileActions,
} from '../../redux/root-action';
import { analyticsTracking, modals } from '../../utils/constants';
import { formatAmountWithoutDecimals, formatAmountWithoutDollarAndDecimals, keyDown } from '../../utils/helpers';
import { getDomain } from '../../utils/api';
import {
  getIncomeGoal,
  getSinglePlan,
  isSinglePlanOtherIncome,
  getTotalCompensation,
  getMultiClientInforation,
  getMulticlientAggregatedCompensation,
  getOtherIncome,
  getOtherIncomeSingleClient,
} from 'selectors';

interface ContentRowProps {
  marginBottom: string;
}
interface StyledLabelProps {
  lineHeight?: string;
}

const StyledLink = styled.a`
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const TileHeaderTitle = styled.div`
  font-family: Nimbus Sans Bold;
  font-size: 20px;
  letter-spacing: -0.3px;
  line-height: 26px;
  color: ${tokens.ColorGrey900};
`;

const RIGTileSubheader = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey700};
  padding-bottom: 16px;
  letter-spacing: 0.4px;
  margin-bottom: 10px;
`;

const ContentRow = styled.div<ContentRowProps>`
  width: 100%;
  display: flex;
  align-items: flex-start;
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 16px;
  ${(props: any) =>
    props.marginBottom &&
    css`
      margin-bottom: ${props.marginBottom + 'px'};
    `}
`;

const InputRow = styled.div`
  border-top: 1px solid ${tokens.ColorWhite100};
  padding-top: 16px;
  display: flex;
  align-items: center;
`;

const StyledInputLabel = styled.div`
  flex: 1;
  font-family: Nimbus Sans Bold;
  font-size: 16px;
`;

const StyledLabel = styled.div<StyledLabelProps>`
  color: ${tokens.ColorGrey800};
  ${(props: any) =>
    props.lineHeight &&
    css`
      line-height: ${props.lineHeight + 'px'};
    `}
`;

const StyledValue = styled.div`
  flex: 1;
  text-align: right;
  color: ${tokens.ColorGrey900};
`;

const StyledPercentValue = styled.div`
  flex: 1;
  text-align: right;
  color: ${tokens.ColorGrey900};
  line-height: 22px;
`;

const StyledIconDiv = styled.div`
  width: 32px;
  text-align: right;
  img {
    vertical-align: top;
  }
`;

const StyledInfoIcon = styled.img`
  margin-left: 4px;
  cursor: pointer;
  height: 12px;
  width: 12px;
`;

const StyledPlanHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-top: 10px;

  :not(:first-of-type) {
    border-top: 1px solid ${tokens.ColorWhite100};
  }
  :target + div {
    display: grid;
  }
`;

const StyledNameAndAmount = styled.div`
  flex: 1;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  padding-bottom: 10px;
  color: ${tokens.ColorGrey900};
`;

const StyledName = styled.div`
  font-family: Nimbus Sans Bold;
  @media all and (-ms-high-contrast: none) {
    width: calc(100% - 32px);
  }
`;

const StyledAmount = styled.div`
  font-family: Nimbus Sans Regular;
`;

const ExpandCollapseIcon = styled.a`
  flex: 0;
  text-decoration: none;
  &:hover,
  &:focus {
    text-decoration: none;
  }
`;

const StyledIcon = styled.img`
  width: 24px;
  height: 24px;
  margin: 0px 8px;
  cursor: pointer;
  @media all and (-ms-high-contrast: none) {
    margin: 0 0 0 -24px;
  }
  @media only screen and (max-width: 767px) {
    width: 32px;
    height: 32px;
  }
`;

const RetirementIncomeGoalContainer = styled.div`
  @keyframes delay-overflow {
    from {
      overflow: hidden;
    }
  }
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out;
  &.expanded {
    max-height: 1500px;
    overflow: visible;
    animation: 0.5s delay-overflow;
  }
`;

const StyledGrid = styled.div`
  display: -ms-grid;
  display: grid;
  grid-template-columns: 50% 3fr;
  column-gap: 24px;
  row-gap: 8px;
  align-items: center;
  .first-column {
    -ms-grid-column: 1;
  }
  .second-column {
    -ms-grid-column: 2;
  }
`;

const StyledText = styled.div<{ row?: number }>`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey800};
  -ms-grid-row: ${props => props.row};
  .bold {
    font-family: Nimbus Sans Bold;
  }
`;

const FocusInput = styled.div`
  height: 0;
  width: 0;
  overflow: hidden;
  display: inline-block;
  > input {
    max-width: 0;
    max-height: 0;
  }
`;

const StyledInput = styled.div`
  -ms-grid-row: 0;
  margin-bottom: 20px;
`;

const DropdownDisplay = styled.div`
  flex-grow: 0;
  ul {
    width: 100%;
  }
`;

const Border = styled.div`
  border-top: 1px solid ${tokens.ColorWhite100};
  padding-top: 16px;
`;
const InputErrorMessage = styled.div`
  grid-column: 1 / span 3;
  font-family: Nimbus Sans Bold;
  color: ${tokens.ColorFunctionalRed700};
  font-size: 16px;
  line-height: 22px;
`;

let showSalaryIcon = false;
let noOfNQPlans = 1;

class RetirementIncomeGoal extends Component<any> {
  props: any;
  state: any;

  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: null,
      isSinglePlan: false,
      isMulticlient: false,
      multiClientInformation: [],
      otherIncomeInformation: null,
      otherIncomeIndex: 101,
      spouseSalaryIndex: 201,
      salaryError: false,
      salaryErrorMessage: '',
      isTerminated: false,
      isSinglePlanOtherIncomeInfo: false,
      singlePlanInformation: [],
      singleClientOtherIncomeStatus: false,
      singleClientOtherIncomeData: null,
      otherSalaryError: false,
      otherSalaryErrorMessage: '',
      spouseExist: false,
    };
  }

  componentDidMount = () => {
    const {
      accounts = [],
      compensations = [],
      fetchPlans,
      spouseProfile,
      multiClientFlag,
      singlePlan,
      isSinglePlanOtherIncome,
      OtherIncomeSingleClientInfo,
    } = this.props;
    fetchPlans();
    const clientNumberSet = new Set();
    // eslint-disable-next-line
    let terminatedAccountsCount = 0;
    const multiClientInfo = [];

    for (let i = 0; i < accounts.length; i++) {
      if (
        accounts[i].status === 'ACTIVE' &&
        (accounts[i].displayAccountCategory === 'RPSNQAccountSummary' ||
          accounts[i].displayAccountCategory === 'NonQualAccountSummary' ||
          accounts[i].displayAccountCategory === 'RPSNQTRACAccountSummary')
      ) {
        noOfNQPlans = noOfNQPlans + 1;
      }
      if (accounts[i].status === 'TERMINATED') {
        terminatedAccountsCount++;
        this.setState({
          isTerminated: true,
        });
      }
      clientNumberSet.add(accounts[i].clientNumber);

      for (const compensation of compensations) {
        if (compensation.clientNumber != null && compensation.clientNumber === accounts[i].clientNumber) {
          const clientNameInfo = this.getClientName(accounts[i].clientNumber);
          const displayPayrollInfo = this.getPayrollFrequencyStatus(
            accounts[i].clientNumber,
            accounts[i].planNumber,
            accounts,
          );
          multiClientInfo.push({
            id: compensation.id,
            action: compensation.action,
            clientNumber: compensation.clientNumber,
            salaryName: accounts[i].name,
            accountId: accounts[i].bpId,
            compensationId: compensation.bpId,
            salary: compensation.amount,
            paymentFrequency: compensation.payFrequency,
            status: accounts[i].status,
            clientName: clientNameInfo,
            displayPayroll: displayPayrollInfo,
            tracPlanNumber: compensation.tracPlanNumber,
            compensationType: compensation.compensationType,
          });
          break;
        }
        if (
          compensation.tracPlanNumber != null &&
          accounts[i].planNumber != null &&
          compensation.tracPlanNumber === accounts[i].planNumber
        ) {
          const clientNameInfo = this.getClientName(compensation.tracPlanNumber);
          const displayPayrollInfo = this.getPayrollFrequencyStatus(
            accounts[i].clientNumber,
            accounts[i].planNumber,
            accounts,
          );
          multiClientInfo.push({
            id: compensation.id,
            action: compensation.action,
            clientNumber: compensation.clientNumber,
            salaryName: accounts[i].name,
            accountId: accounts[i].bpId,
            compensationId: compensation.bpId,
            salary: compensation.amount,
            paymentFrequency: compensation.payFrequency,
            status: accounts[i].status,
            clientName: clientNameInfo,
            displayPayroll: displayPayrollInfo,
            tracPlanNumber: compensation.tracPlanNumber,
            compensationType: compensation.compensationType,
          });
          break;
        }
      }
    }

    let otherIncomeDetailsInfo = null;

    if (compensations != null) {
      for (let i = 0; i < compensations.length; i++) {
        /** Other Income Information */
        for (let j = i + 1; j < compensations.length; j++) {
          if (
            compensations[i].bpId === compensations[j].bpId &&
            compensations[j].clientNumber === null &&
            compensations[j].tracPlanNumber === null
          ) {
            otherIncomeDetailsInfo = {
              id: compensations[j].id,
              compensationType: compensations[j].compensationType,
              bpId: compensations[j].bpId,
              clientNumber: compensations[j].clientNumber,
              amount: compensations[j].amount,
            };
          }
        }
      }
    }
    /** Spouse Information */
    let spouseInfo = null;
    let doesSpouseExist = false;
    for (const compensation of compensations) {
      if (spouseProfile && spouseProfile.bpId === compensation.bpId) {
        doesSpouseExist = true;
        spouseInfo = {
          id: compensation.id,
          compensationType: compensation.compensationType,
          bpId: compensation.bpId,
          clientNumber: compensation.clientNumber,
          amount: compensation.amount,
        };
      }
    }

    this.setState({
      spouseExist: doesSpouseExist,
      spouseInformation: spouseInfo,
      otherIncomeInformation: otherIncomeDetailsInfo,
      multiClientInformation: multiClientInfo,
      isMulticlient: multiClientFlag,
      isSinglePlan: singlePlan.length > 0,
      singlePlanInformation: singlePlan,
      isSinglePlanOtherIncomeInfo: isSinglePlanOtherIncome,
      singleClientOtherIncomeStatus: OtherIncomeSingleClientInfo != null && OtherIncomeSingleClientInfo.amount > 0,
      singleClientOtherIncomeData: OtherIncomeSingleClientInfo,
    });
  };

  getPayrollFrequencyStatus = (clientNumber: string, planNumber: string, accounts: any): boolean => {
    let status = false;
    if (clientNumber == null && planNumber != null) {
      for (let i = 0; i < accounts.length; i++) {
        if (accounts[i].planNumber === planNumber && accounts[i].contribution != null) {
          for (let j = 0; j < accounts[i].contribution.length; j++) {
            if (accounts[i].contribution[j].unit === 'DOL') {
              status = true;
              break;
            }
          }
        }
      }
    }
    if (clientNumber != null) {
      for (let i = 0; i < accounts.length; i++) {
        if (accounts[i].clientNumber === clientNumber && accounts[i].contribution != null) {
          for (let j = 0; j < accounts[i].contribution.length; j++) {
            if (accounts[i].contribution[j].unit === 'DOL') {
              status = true;
              break;
            }
          }
        }
      }
    }
    return status;
  };

  // displayPayrollFrequency = (contributions:any): boolean => {
  //   let result: boolean = false;
  //   if (contributions) {
  //     for (let contribution of contributions){
  //       if (contribution.unit =='DOL') {
  //         result = true;
  //         break;
  //       }
  //     }
  //   }
  //   return result ;
  // }

  getClientName = (clientNumber: string): string => {
    const { plans } = this.props;
    let clientName = '';
    plans.forEach((plan: any) => {
      if (plan.clientNumber === clientNumber) {
        clientName = plan.clientName;
        return;
      }
      if (plan.tracPlan === true && plan.planNumber === clientNumber) {
        clientName = plan.planName;
      }
    });
    return clientName;
  };

  validateAndUpdatePercent = (e: any) => {
    const {
      updateRetirementIncomeGoalData,
      retirementIncomeGoal: {
        tempScenario: { participantSalary, spouseSalary },
      },
      multiclientAggregatedCompensation,
    } = this.props;
    const allowedCharacters = /^[0-9,\b]+$/;

    if (e.target.value === '' || allowedCharacters.test(e.target.value)) {
      const tempValue = e.target.value.replace(/,/g, '');
      let updatedPercent = 0;
      if (this.state.isMulticlient) {
        updatedPercent = Math.floor((tempValue / multiclientAggregatedCompensation) * 100);
      } else if (
        this.state.isSinglePlan ||
        this.state.isSinglePlanOtherIncomeInfo ||
        this.state.singleClientOtherIncomeStatus
      ) {
        let total = 0;
        this.state.singlePlanInformation.forEach((data: any) => {
          total += data.salary;
        });
        if (this.state.singleClientOtherIncomeStatus) {
          total += this.state.singleClientOtherIncomeData.amount;
        }
        updatedPercent = Math.floor((tempValue / total) * 100);
      } else {
        updatedPercent = Math.floor((tempValue / (participantSalary + spouseSalary)) * 100);
      }
      updateRetirementIncomeGoalData({
        incomeGoal: tempValue,
        compensationPercent: updatedPercent,
      });
    }
  };

  showRetirementIncomeModal = () => {
    const { showModal } = this.props;
    showModal(modals.RETIREMENT_INCOME);
  };

  handleDone = () => {
    const { modelRetirementIncomeGoalScenario, hideInputTilePopover } = this.props;
    modelRetirementIncomeGoalScenario();
    hideInputTilePopover();
  };

  handleCancel = () => {
    const {
      hideInputTilePopover,
      updateRetirementIncomeGoalData,
      retirementIncomeGoal: { modelledScenario },
    } = this.props;
    updateRetirementIncomeGoalData(modelledScenario);
    hideInputTilePopover();
  };

  showSpouseProfileModal = () => {
    const { showModal, hideInputTilePopover } = this.props;
    hideInputTilePopover();
    showModal(modals.ADD_SPOUSE_PROFILE);
  };

  showRIGSalaryModal = () => {
    const { showModal } = this.props;
    showModal(modals.RIG_SALARY_MODAL);
  };

  showRIGSalaryModalOnKeyPress = (e: any) => {
    if (e.nativeEvent.code === 'Enter') {
      this.showRIGSalaryModal();
    }
  };

  showRIGOtherIncomeModal = () => {
    const { showModal } = this.props;
    showModal(modals.RIG_OTHER_INCOME_MODAL);
  };

  toggleAccordion = (id: any) => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: isOpen === id ? null : id,
    });
  };

  handleOptionChange = (index: number, option: any) => {
    const { updateRetirementIncomeGoalData } = this.props;
    const multiClientInformationCopy = [...this.state.multiClientInformation];
    const tempPaymentFrequencyValue = option.value;
    if (tempPaymentFrequencyValue !== null && tempPaymentFrequencyValue !== '') {
      const multiclientData = multiClientInformationCopy[index];
      multiclientData.paymentFrequency = tempPaymentFrequencyValue;
      updateRetirementIncomeGoalData({
        multiClientInformationData: multiClientInformationCopy,
      });
    }
  };

  handleMultilcientSpouseChange = (e: any) => {
    const { updateRetirementIncomeGoalData } = this.props;
    const { spouseInformation } = this.state;
    const allowedCharacters = /^[0-9,\b]+$/;
    let tempSpouseValue = e.target.value;
    if (tempSpouseValue !== null && tempSpouseValue !== '' && allowedCharacters.test(tempSpouseValue)) {
      tempSpouseValue = e.target.value.replace(/,/g, '');
      const spouseInformationDetails = spouseInformation;
      spouseInformationDetails.amount = tempSpouseValue;
      updateRetirementIncomeGoalData({
        spouseInformationData: spouseInformationDetails,
      });
    }
  };

  handleOtherIncomeChanges = (e: any) => {
    const { updateRetirementIncomeGoalData } = this.props;
    const { otherIncomeInformation } = this.state;
    const allowedCharacters = /^[0-9,\b]+$/;
    let tempOtherIncome = e.target.value;
    if (tempOtherIncome !== null && tempOtherIncome !== '' && allowedCharacters.test(tempOtherIncome)) {
      tempOtherIncome = e.target.value.replace(/,/g, '');
      const otherIncomeDetails = otherIncomeInformation;
      otherIncomeDetails.amount = tempOtherIncome;
      updateRetirementIncomeGoalData({
        otherIncome: otherIncomeDetails,
      });
    }
  };

  displayPaycheckFrequest = (payCheckFrequency: string): string => {
    let frequency = '';
    if (payCheckFrequency !== null && payCheckFrequency !== undefined) {
      switch (payCheckFrequency) {
        case 'MLY':
          frequency = 'Monthly';
          break;
        case 'TWMLY':
          frequency = 'Semi-Monthly';
          break;
        case 'BIWLY':
          frequency = 'Bi-Weekly';
          break;
        case 'WKLY':
          frequency = 'Weekly';
          break;
        case 'NTSP':
          frequency = 'Select';
          break;
        default:
          break;
      }
    }
    return frequency;
  };

  handleSinglePlanOptionChange = (index: number, option: any) => {
    const { updateRetirementIncomeGoalData } = this.props;
    const singlePlanCopy = [...this.state.singlePlanInformation];
    const tempPaymentFrequencyValue = option.value;
    if (tempPaymentFrequencyValue !== null && tempPaymentFrequencyValue !== '') {
      const singplePlanData = singlePlanCopy[index];
      singplePlanData.paymentFrequency = tempPaymentFrequencyValue;
      updateRetirementIncomeGoalData({
        singlePlanInformationData: singlePlanCopy,
      });
    }
  };

  handleSingleClientOtherIncomeChanges = (e: any) => {
    const { updateRetirementIncomeGoalData } = this.props;
    const allowedCharacters = /^[0-9,\b]+$/;
    let tempOtherIncome = e.target.value;
    // console.log("tempOtherIncome "+ tempOtherIncome);
    // console.log("this.state.singleClientOtherIncomeData "+ JSON.stringify(this.state.singleClientOtherIncomeData));
    if (tempOtherIncome !== null && tempOtherIncome !== '' && allowedCharacters.test(tempOtherIncome)) {
      tempOtherIncome = e.target.value.replace(/,/g, '');
      const otherIncomeDetails = this.state.singleClientOtherIncomeData;
      otherIncomeDetails.amount = tempOtherIncome;
      if (tempOtherIncome <= 5000) {
        this.setState({
          otherSalaryError: true,
          otherSalaryErrorMessage: 'Salary should be greater than 5000',
        });
      } else {
        this.setState({
          otherSalaryError: false,
          otherSalaryErrorMessage: '',
          singleClientOtherIncomeData: otherIncomeDetails,
        });
      }
      updateRetirementIncomeGoalData({
        otherIncome: otherIncomeDetails,
      });
      // console.log("handleSingleClientOtherIncomeChanges "+ JSON.stringify(otherIncomeDetails));
    }
  };

  handleSinglePlanInputChange = (index: number, status: string) => {
    return (e: any) => {
      const { updateRetirementIncomeGoalData } = this.props;
      const allowedCharacters = /^[0-9,\b]+$/;
      const singlePlanCopy = [...this.state.singlePlanInformation];
      let tempSalaryValue = e.target.value;
      if (tempSalaryValue !== null && tempSalaryValue !== '' && allowedCharacters.test(tempSalaryValue)) {
        tempSalaryValue = e.target.value.replace(/,/g, '');
        const singlePlanData = singlePlanCopy[index];
        singlePlanData.salary = tempSalaryValue;
        if (status === 'ACTIVE' && tempSalaryValue <= 5000) {
          this.setState({
            salaryError: true,
            salaryErrorMessage: 'Salary should be greater than 5000',
          });
        } else {
          this.setState({
            salaryError: false,
            salaryErrorMessage: '',
            singlePlanCopy,
          });
          updateRetirementIncomeGoalData({
            singlePlanInformationData: singlePlanCopy,
          });
        }
      }
    };
  };

  handleMultiSalaryInputChange = (salaryIndex: number, status: string) => {
    return (e: any) => {
      const { updateRetirementIncomeGoalData } = this.props;

      const allowedCharacters = /^[0-9,\b]+$/;
      const multiClientInformationCopy = [...this.state.multiClientInformation];
      let tempSalaryValue = e.target.value;

      if (tempSalaryValue !== null && tempSalaryValue !== '' && allowedCharacters.test(tempSalaryValue)) {
        tempSalaryValue = e.target.value.replace(/,/g, '');
        const multiclientData = multiClientInformationCopy[salaryIndex];
        multiclientData.salary = tempSalaryValue;

        if ((status === 'ACTIVE' && tempSalaryValue <= 5000) || (this.state.isTerminated && tempSalaryValue <= 5000)) {
          this.setState({
            salaryError: true,
            salaryErrorMessage: 'Salary should be greater than 5000',
          });
        } else {
          this.setState({
            salaryError: false,
            salaryErrorMessage: '',
            multiClientInformationCopy,
          });

          updateRetirementIncomeGoalData({
            multiClientInformationData: multiClientInformationCopy,
          });
        }
      }
    };
  };

  render(): JSX.Element {
    const {
      accounts = [],
      retirementIncomeGoal: {
        tempScenario: {
          incomeGoal,
          participantSalary,
          spouseSalary,
          hasSpouse,
          multiClientInformationData,
          otherIncome,
          spouseInformationData,
          singlePlanInformationData,
        },
      },
      initialIncomeGoal,
      totalCompensation,
      multiclientAggregatedCompensation,
      otherIncomeAmount,
    } = this.props;

    const { isOpen, isMulticlient, otherIncomeIndex, spouseSalaryIndex, spouseExist } = this.state;
    const multiClientData =
      multiClientInformationData == null ? this.state.multiClientInformation : multiClientInformationData;
    const multiClientSpouse = spouseInformationData == null ? spouseSalary : spouseInformationData.amount;
    const otherIncomeInfo = otherIncome == null ? otherIncomeAmount : otherIncome.amount;

    const singlePlanInfo =
      singlePlanInformationData == null ? this.state.singlePlanInformation : singlePlanInformationData;
    let singleClientOtherIncome = 0;
    // console.log(" singleClientOtherIncomeStatus: "+ this.state.singleClientOtherIncomeStatus
    // + " singleClientOtherIncome-Before: "+ singleClientOtherIncome + " otherIncome-Before: "+ otherIncome);
    if (otherIncome == null && this.state.singleClientOtherIncomeStatus) {
      singleClientOtherIncome = this.state.singleClientOtherIncomeData.amount;
    }
    if (otherIncome != null && otherIncome.amount != null) {
      singleClientOtherIncome = otherIncome.amount;
    }
    // console.log(" singleClientOtherIncomeStatus: "+ this.state.singleClientOtherIncomeStatus
    // + " singleClientOtherIncome-After: "+ singleClientOtherIncome + " otherIncome-After: "+ otherIncome);
    let totalCompensationInfo = totalCompensation;
    
    if (this.state.isMulticlient) {
      totalCompensationInfo = multiclientAggregatedCompensation;
    }


    const compensationPercent =
      totalCompensationInfo > 0
        ? Math.floor(((incomeGoal === null ? initialIncomeGoal : incomeGoal) / totalCompensationInfo) * 100)
        : 0;

    for (let i = 0; i < accounts.length; i++) {
      if (
        accounts[i].status === 'ACTIVE' &&
        (accounts[i].displayAccountCategory === 'RPSNQAccountSummary' ||
          accounts[i].displayAccountCategory === 'NonQualAccountSummary' ||
          accounts[i].displayAccountCategory === 'RPSNQTRACAccountSummary')
      ) {
        showSalaryIcon = true;
        break;
      }
    }

    return (
      <React.Fragment>
        <InputTilePopoverCard
          handleDone={this.handleDone}
          handleCancel={this.handleCancel}
          analyticsId={analyticsTracking.RIXRIGInputTileDone}
          cancelId={analyticsTracking.RIXRIGInputTileCancel}
        >
          <FocusInput id={'focus-input'}>
            <input aria-label="Hidden input" autoFocus />
          </FocusInput>
          <TileHeaderTitle id="po-tile-header-title">Retirement Income Goal</TileHeaderTitle>
          <RIGTileSubheader id="po-rig-percentage-salary">
            {compensationPercent}% of {spouseSalary ? 'your household salary' : 'your salary'}
          </RIGTileSubheader>
          {!this.state.isMulticlient && <Border />}

          {this.state.isMulticlient ? (
            <React.Fragment>
              {multiClientData.map((data: any, salaryIndex: number) => {
                return (
                  <React.Fragment key={salaryIndex}>
                    <StyledPlanHeader id={`mc-plan-header-` + salaryIndex}>
                      <StyledNameAndAmount id={`mc-name-amount-` + salaryIndex}>
                        <StyledName id={`mc-header-name-` + salaryIndex}>
                          {`Your ` + data.clientName + ` Salary`}
                        </StyledName>
                        <StyledAmount id={`mc-header-salary-` + salaryIndex}>
                          {formatAmountWithoutDecimals(data.salary) + '/yr'}
                        </StyledAmount>
                      </StyledNameAndAmount>
                      <ExpandCollapseIcon id={`mc-expand-collapse-icon` + salaryIndex}>
                        <StyledIcon
                          id={'mc-exp-col-icon-' + salaryIndex}
                          src={`data:image/svg+xml;base64,${isOpen === salaryIndex ? tokens.AssetIconMinusOutline : tokens.AssetIconPlusOutline
                            }`}
                          alt="plus icon"
                          onClick={() => this.toggleAccordion(salaryIndex)}
                          tabIndex={0}
                          onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                            keyDown(e, () => this.toggleAccordion(salaryIndex))
                          }
                        />
                      </ExpandCollapseIcon>
                    </StyledPlanHeader>

                    <RetirementIncomeGoalContainer
                      id={`mc-rig-container` + salaryIndex}
                      className={isOpen === salaryIndex || !isMulticlient ? 'expanded' : ''}
                    >
                      <StyledGrid id={`mc-grid-` + salaryIndex} style={{ marginBottom: '16px' }}>
                        <StyledLink
                          id={`mc-link-` + salaryIndex}
                          tabIndex={0}
                          onClick={this.showRIGSalaryModal}
                          onKeyPress={this.showRIGSalaryModalOnKeyPress}
                        >
                          <StyledText className="first-column" row={salaryIndex + 2} id={`mc-name-index` + salaryIndex}>
                            {`Your ` + data.clientName + ` Salary`}
                            <StyledInfoIcon
                              id={'mc-info-icon-' + salaryIndex}
                              src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                              alt="Savings info icon"
                            />
                          </StyledText>
                        </StyledLink>

                        <StyledInput id={`mc-input-` + salaryIndex} className="second-column">
                          <Input
                            name="MultiSalary"
                            value={formatAmountWithoutDollarAndDecimals(data.salary || 0)}
                            onChange={this.handleMultiSalaryInputChange(salaryIndex, data.status)}
                            placeholder=""
                            autoComplete="off"
                            aria-label="MultiSalary"
                            width={150}
                            errorMessage={''}
                            leadingCharacter={'$'}
                            trailingCharacter={'/yr.'}
                            textAlign={'right'}
                            tabIndex={isOpen === salaryIndex ? 0 : -1}
                            id={`mc-salaryindex-` + salaryIndex}
                          />
                        </StyledInput>

                        {this.state.salaryError && (
                          <InputErrorMessage id={`mc-error`}>{this.state.salaryErrorMessage}</InputErrorMessage>
                        )}

                        {data.displayPayroll && (
                          <React.Fragment>
                            <StyledText className="first-column" row={salaryIndex + 2} id={`mc-paycheck`}>
                              Paycheck Frequency
                            </StyledText>

                            <DropdownDisplay id={`mc-dropdown-display-` + salaryIndex}>
                              <Dropdown
                                label={this.displayPaycheckFrequest(data.paymentFrequency)}
                                options={[
                                  {
                                    name: 'Monthly',
                                    value: 'MLY',
                                    id: 'Monthly',
                                  },
                                  {
                                    name: 'Semi-Monthly',
                                    value: 'TWMLY',
                                    id: 'Semi-Monthly',
                                  },
                                  {
                                    name: 'Bi-Weekly',
                                    value: 'BIWLY',
                                    id: 'Bi-Weekly',
                                  },
                                  {
                                    name: 'Weekly',
                                    value: 'WKLY',
                                    id: 'Weekly',
                                  },
                                ]}
                                onChange={(option: any) => this.handleOptionChange(salaryIndex, option)}
                                selectedOption={
                                  data.paymentFrequency !== null && data.paymentFrequency !== undefined
                                    ? data.paymentFrequency
                                    : 'MLY'
                                }
                                name="payCheckFrequency"
                                width={'100%'}
                                id={`mc-paycheck-value`}
                              ></Dropdown>
                            </DropdownDisplay>
                          </React.Fragment>
                        )}
                      </StyledGrid>
                    </RetirementIncomeGoalContainer>
                  </React.Fragment>
                );
              })}

              {otherIncomeInfo > 0 && (
                <React.Fragment key={otherIncomeIndex}>
                  <StyledPlanHeader id={`mc-other-income-header-name`}>
                    <StyledNameAndAmount id={`mc-other-income-name-amount`}>
                      <StyledName id={`mc-oth-inc-header-name`}>{`Other Income`}</StyledName>
                      <StyledAmount id={`mc-oth-inc-header-salary`}>
                        {formatAmountWithoutDecimals(otherIncomeInfo) + '/yr'}
                      </StyledAmount>
                    </StyledNameAndAmount>
                    <ExpandCollapseIcon id={`mc-other-income-expand-icon`}>
                      <StyledIcon
                        id={'mc-oth-inc-exp-col-icon-' + otherIncomeIndex}
                        src={`data:image/svg+xml;base64,${isOpen === otherIncomeIndex ? tokens.AssetIconMinusOutline : tokens.AssetIconPlusOutline
                          }`}
                        alt="plus icon"
                        onClick={() => this.toggleAccordion(otherIncomeIndex)}
                        tabIndex={0}
                        onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                          keyDown(e, () => this.toggleAccordion(otherIncomeIndex))
                        }
                      />
                    </ExpandCollapseIcon>
                  </StyledPlanHeader>

                  <RetirementIncomeGoalContainer
                    id={`mc-other-income-rig`}
                    className={isOpen === otherIncomeIndex || !isMulticlient ? 'expanded' : ''}
                  >
                    <StyledGrid id={`mc-other-grid`}>
                      <StyledText
                        className="first-column"
                        row={otherIncomeIndex + 2}
                        style={{ marginTop: '-24px' }}
                        id={`mc-oth-inc-name`}
                      >
                        {`Other Income`}
                        <StyledInfoIcon
                          id={`mc-other-info-icon`}
                          src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                          alt="Savings info icon"
                          onClick={this.showRIGOtherIncomeModal}
                          tabIndex={0}
                          onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                            keyDown(e, () => this.showRIGOtherIncomeModal)
                          }
                        />
                      </StyledText>
                      <StyledInput id={`mc-other-input`} className="second-column">
                        <Input
                          name="MultiSalary"
                          onChange={this.handleOtherIncomeChanges}
                          value={formatAmountWithoutDollarAndDecimals(otherIncomeInfo)}
                          placeholder=""
                          autoComplete="off"
                          aria-label="MultiSalary"
                          width={150}
                          errorMessage={''}
                          leadingCharacter={'$'}
                          trailingCharacter={'/yr.'}
                          textAlign={'right'}
                          tabIndex={isOpen === otherIncomeInfo ? otherIncomeIndex : -1}
                          id={`mc-oth-inc-salary`}
                        />
                      </StyledInput>
                    </StyledGrid>
                  </RetirementIncomeGoalContainer>
                </React.Fragment>
              )}

              {hasSpouse && spouseExist && (
                <React.Fragment key={spouseSalaryIndex}>
                  <StyledPlanHeader id={`mc-spouse-plan-header`}>
                    <StyledNameAndAmount id={`mc-spouse-name-amount`}>
                      <StyledName id={`mc-spouse-header-name`}>Spouse&#39;s Salary</StyledName>
                      <StyledAmount id={`mc-spouse-header-salary`}>
                        {formatAmountWithoutDecimals(multiClientSpouse)}
                      </StyledAmount>
                    </StyledNameAndAmount>
                    <ExpandCollapseIcon id={`mc-spouse-expand-collapse`}>
                      <StyledIcon
                        id={'mc-sp-exp-col-icon-' + spouseSalaryIndex}
                        src={`data:image/svg+xml;base64,${isOpen === spouseSalaryIndex ? tokens.AssetIconMinusOutline : tokens.AssetIconPlusOutline
                          }`}
                        alt="plus icon"
                        onClick={() => this.toggleAccordion(spouseSalaryIndex)}
                        tabIndex={0}
                        onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                          keyDown(e, () => this.toggleAccordion(spouseSalaryIndex))
                        }
                      />
                    </ExpandCollapseIcon>
                  </StyledPlanHeader>

                  <RetirementIncomeGoalContainer
                    id={`mc-spouse-rig`}
                    className={isOpen === spouseSalaryIndex || !isMulticlient ? 'expanded' : ''}
                  >
                    <StyledGrid id={`mc-spouse-grid`}>
                      <StyledLink
                        id={`mc-spouse-link`}
                        tabIndex={0}
                        onClick={this.showRIGSalaryModal}
                        onKeyPress={this.showRIGSalaryModalOnKeyPress}
                      >
                        <StyledText
                          className="first-column"
                          row={spouseSalaryIndex + 2}
                          style={{ marginTop: '-24px' }}
                          id={`mc-spouse-name`}
                        >
                          Spouse&#39;s Salary
                          <StyledInfoIcon
                            id={`mc-spouse-icon`}
                            src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                            alt="Savings info icon"
                          />
                        </StyledText>
                      </StyledLink>
                      <StyledInput id={`mc-spouse-input`} className="second-column">
                        <Input
                          name="MultiSalary"
                          onChange={this.handleMultilcientSpouseChange}
                          value={formatAmountWithoutDollarAndDecimals(multiClientSpouse)}
                          placeholder=""
                          autoComplete="off"
                          aria-label="MultiSalary"
                          width={150}
                          errorMessage={''}
                          leadingCharacter={'$'}
                          trailingCharacter={'/yr.'}
                          textAlign={'right'}
                          tabIndex={isOpen === multiClientSpouse ? spouseSalaryIndex : -1}
                          id={`mc-spouse-salary`}
                        />
                      </StyledInput>
                    </StyledGrid>
                  </RetirementIncomeGoalContainer>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : this.state.isSinglePlan || this.state.isSinglePlanOtherIncomeInfo ? (
            <React.Fragment>
              {singlePlanInfo.map((data: any, index: number) => {
                return (
                  <React.Fragment key={index}>
                    <StyledGrid id={`sp-grid`} style={{ marginBottom: '16px' }}>
                      <StyledLink
                        id={`sp-grid-link`}
                        tabIndex={0}
                        onClick={this.showRIGSalaryModal}
                        onKeyPress={this.showRIGSalaryModalOnKeyPress}
                      >
                        <StyledText
                          id={this.state.isSinglePlanOtherIncomeInfo ? 'sp-other-income' : `sp-your-salary`}
                          className="first-column"
                          row={index + 2}
                        >
                          {this.state.isSinglePlanOtherIncomeInfo ? 'Other Income ' : `Your Salary `}
                          <StyledInfoIcon
                            src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                            alt="Savings info icon"
                            id={this.state.isSinglePlanOtherIncomeInfo ? 'other-income' : `your-salary`}
                          />
                        </StyledText>
                      </StyledLink>
                      <StyledInput id={`sp-input`} className="second-column">
                        <Input
                          name="MultiSalary"
                          value={formatAmountWithoutDollarAndDecimals(data.salary || 0)}
                          onChange={this.handleSinglePlanInputChange(index, data.status)}
                          placeholder=""
                          autoComplete="off"
                          aria-label="MultiSalary"
                          width={150}
                          errorMessage={''}
                          leadingCharacter={'$'}
                          trailingCharacter={'/yr.'}
                          textAlign={'right'}
                          tabIndex={isOpen === index ? 0 : -1}
                          id={`sc-salary`}
                        />
                      </StyledInput>

                      {this.state.salaryError && (
                        <InputErrorMessage id={`sc-error`}>{this.state.salaryErrorMessage}</InputErrorMessage>
                      )}

                      {data.displayPayroll && (
                        <React.Fragment>
                          <StyledText className="first-column" row={index + 2} id={`sc-paycheck`}>
                            Paycheck Frequency
                          </StyledText>

                          <DropdownDisplay id={`sp-dropdown-display`}>
                            <Dropdown
                              label={this.displayPaycheckFrequest(data.paymentFrequency)}
                              options={[
                                {
                                  name: 'Monthly',
                                  value: 'MLY',
                                  id: 'Monthly',
                                },
                                {
                                  name: 'Semi-Monthly',
                                  value: 'TWMLY',
                                  id: 'Semi-Monthly',
                                },
                                {
                                  name: 'Bi-Weekly',
                                  value: 'BIWLY',
                                  id: 'Bi-Weekly',
                                },
                                {
                                  name: 'Weekly',
                                  value: 'WKLY',
                                  id: 'Weekly',
                                },
                              ]}
                              onChange={(option: any) => this.handleSinglePlanOptionChange(index, option)}
                              selectedOption={
                                data.paymentFrequency !== null && data.paymentFrequency !== undefined
                                  ? data.paymentFrequency
                                  : 'MLY'
                              }
                              name="payCheckFrequency"
                              width={'100%'}
                              id={`sc-paycheck-value`}
                            ></Dropdown>
                          </DropdownDisplay>
                        </React.Fragment>
                      )}
                    </StyledGrid>
                    {this.state.singleClientOtherIncomeStatus && !this.state.isSinglePlanOtherIncomeInfo && (
                      <React.Fragment>
                        <StyledGrid id={`sp-other-income-grid`} style={{ marginBottom: '16px' }}>
                          <StyledLink
                            id={`sp-other-income-link`}
                            tabIndex={0}
                            onClick={this.showRIGSalaryModal}
                            onKeyPress={this.showRIGSalaryModalOnKeyPress}
                          >
                            <StyledText className="first-column" row={index + 2} id={`sc-otherincome`}>
                              {'Other Income '}
                              <StyledInfoIcon
                                src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                                alt="Savings info icon"
                              />
                            </StyledText>
                          </StyledLink>
                          <StyledInput id={`sp-other-income-input`} className="second-column">
                            <Input
                              name="OtherIncomeSingleClientSalary"
                              value={formatAmountWithoutDollarAndDecimals(singleClientOtherIncome)}
                              onChange={this.handleSingleClientOtherIncomeChanges}
                              placeholder=""
                              autoComplete="off"
                              aria-label="Other Income"
                              width={150}
                              errorMessage={''}
                              leadingCharacter={'$'}
                              trailingCharacter={'/yr.'}
                              textAlign={'right'}
                              tabIndex={isOpen === index ? 0 : -1}
                              id={`sc-otherincome-value`}
                            />
                          </StyledInput>
                          {this.state.otherSalaryError && (
                            <InputErrorMessage id={`sc-otherincome-error`}>
                              {this.state.otherSalaryErrorMessage}
                            </InputErrorMessage>
                          )}
                        </StyledGrid>
                      </React.Fragment>
                    )}

                    {hasSpouse && spouseExist && (
                      <ContentRow id={`sp-spouse-content-row`} marginBottom={'24'}>
                        <StyledLabel id={'rig-spouse-salary-name'}>Spouse&#39;s Salary</StyledLabel>
                        <StyledValue className="blocked_data" id={'rig-spouse-salary'}>
                          {formatAmountWithoutDecimals(spouseSalary)}
                        </StyledValue>
                        <StyledIconDiv id={`sp-spouse-icon`}>
                          <Link
                            id={analyticsTracking.RIXRIGInputTileSpouseSalary}
                            linkLabel={
                              <img
                                width="16"
                                height="16"
                                style={{ marginLeft: 16 }}
                                src={`data:image/svg+xml;base64,${tokens.AssetIconEdit}`}
                                alt="Edit Icon"
                                id={`po-rig-spouse-salary-value`}
                              />
                            }
                            onClick={this.showSpouseProfileModal}
                            tabIndex={0}
                            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) =>
                              keyDown(e, this.showSpouseProfileModal)
                            }
                          />
                        </StyledIconDiv>
                      </ContentRow>
                    )}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ContentRow marginBottom={'16'}>
                <StyledLabel>
                  Your Salary
                  {showSalaryIcon && (
                    <StyledLink
                      tabIndex={0}
                      onClick={this.showRIGSalaryModal}
                      onKeyPress={this.showRIGSalaryModalOnKeyPress}
                    >
                      <StyledInfoIcon
                        src={`data:image/svg+xml;base64,${tokens.AssetIconInfoOutline}`}
                        alt="Savings info icon"
                      />
                    </StyledLink>
                  )}
                </StyledLabel>
                <StyledValue className="blocked_data" id="PO-RIGPrimarySalary">
                  {formatAmountWithoutDecimals(participantSalary)}
                </StyledValue>
                <StyledIconDiv>
                  <Link
                    linkLabel={
                      <img
                        width="16"
                        height="16"
                        style={{ marginLeft: 16 }}
                        src={`data:image/svg+xml;base64,${tokens.AssetIconEdit}`}
                        alt="Edit Icon"
                        id={analyticsTracking.RIXRIGInputTileYourSalary}
                      />
                    }
                    href={getDomain() + '/rps/rws/account/participant/profile.otc'}
                  />
                </StyledIconDiv>
              </ContentRow>
              {hasSpouse && (
                <ContentRow marginBottom={'24'}>
                  <StyledLabel>Spouse&#39;s Salary</StyledLabel>
                  <StyledValue className="blocked_data" id={'po-rig-spouse-salary'}>
                    {formatAmountWithoutDecimals(spouseSalary)}
                  </StyledValue>
                  <StyledIconDiv>
                    <Link
                      id={analyticsTracking.RIXRIGInputTileSpouseSalary}
                      linkLabel={
                        <img
                          width="16"
                          height="16"
                          style={{ marginLeft: 16 }}
                          src={`data:image/svg+xml;base64,${tokens.AssetIconEdit}`}
                          alt="Edit Icon"
                          id={analyticsTracking.RIXRIGInputTileYourSalary}
                        />
                      }
                      onClick={this.showSpouseProfileModal}
                      tabIndex={0}
                      onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showSpouseProfileModal)}
                    />
                  </StyledIconDiv>
                </ContentRow>
              )}
            </React.Fragment>
          )}

          {this.state.isMulticlient && <Border />}
          <ContentRow marginBottom={'8'}>
            <StyledLabel lineHeight={'22'} id={`rig-per-sal-needed-display`}>
              {hasSpouse ? '% of Salaries Listed Above Needed in Retirement' : '% of Salary Needed in Retirement'}
            </StyledLabel>
            <StyledPercentValue id="rig-per-salary-needed">{compensationPercent}%</StyledPercentValue>
          </ContentRow>

          <ContentRow marginBottom={'24'}>
            <StyledLabel>
              <Link
                linkLabel="How is this calculated?"
                onClick={this.showRetirementIncomeModal}
                tabIndex={0}
                onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.showRetirementIncomeModal)}
                color={tokens.ColorBrandInteractiveBlue}
                hoverColor={tokens.ColorBrandInteractiveBlueHover}
                id={'PO-RIGLink'}
              />
            </StyledLabel>
          </ContentRow>
          <InputRow>
            <StyledInputLabel id={'po-rig-input-boxname'}>Retirement Income Goal</StyledInputLabel>
            <Input
              name="retirementIncomeGoal"
              onChange={this.validateAndUpdatePercent}
              value={formatAmountWithoutDollarAndDecimals(incomeGoal === null ? initialIncomeGoal : incomeGoal)}
              leadingCharacter="$"
              autoComplete="off"
              aria-label="Retirement Income Goal"
              maxLength={10}
              width={120}
              textAlign={'right'}
              id={'PO-RIGInputBox'}
              tabIndex={0}
            />
          </InputRow>
        </InputTilePopoverCard>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  const {
    account: {
      modelledScenario: { accounts },
    },
    retirementIncomeGoal,
    contribution,
    participantProfile,
    riScenario,
  } = state;
  return {
    accounts,
    retirementIncomeGoal,
    initialIncomeGoal: getIncomeGoal(state),
    singlePlan: getSinglePlan(state),
    totalCompensation: getTotalCompensation(state),
    isSinglePlanOtherIncome: isSinglePlanOtherIncome(state),
    contribution,
    compensations: riScenario.compensations,
    spouseProfile: riScenario.spouseProfile,
    plans: participantProfile.plans,
    multiClientFlag: getMultiClientInforation(state),
    multiclientAggregatedCompensation: getMulticlientAggregatedCompensation(state),
    otherIncomeAmount: getOtherIncome(state),
    OtherIncomeSingleClientInfo: getOtherIncomeSingleClient(state),
  };
};

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideInputTilePopover: inputTilesActions.hideInputTilePopover,
  updateRetirementIncomeGoalData: retirementIncomeGoalActions.updateRetirementIncomeGoalData,
  modelRetirementIncomeGoalScenario: retirementIncomeGoalActions.modelRetirementIncomeGoalScenario,
  fetchRIScenario: riScenarioActions.fetchRIScenario,
  fetchPlans: participantProfileActions.fetchPlans,
})(RetirementIncomeGoal);
